import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

function Login() {
  const navigate = useNavigate();
  const email = useRef("");
  const password = useRef("");
  const [button, setButton] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
      navigate("/dashboard");
    }
  }, []);

  async function loginUser() {
    const userData = {
      email: email.current.value,
      password: password.current.value,
    };
    try {
      const res = await api.post("/admin/login", userData, {
        headers: {
          // "x-access-token": "token-value",
        },
      });
      if (res.data.success) {

        // store the user in localStorage
        localStorage.setItem('token', res.data.user['token']);
        localStorage.setItem('user', JSON.stringify(res.data.user));

        swal("Success!", res.data.message, "success", {
          button: false,
          timer: 1500,
        });
        navigate("/dashboard");

      }
    } catch (err) {
      swal("Login Failed!", "" + err.response.data.message, "error", {
        button: false,
        timer: 1500
      });
    }
  }

  return (
    <div>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4">
                  <a
                    href="/"
                    className="logo d-flex align-items-center w-auto"
                  >
                    <img src="assets/img/logo.png" alt="" />
                    <span className="d-none d-lg-block">Xtrava Admin</span>
                  </a>
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Login to Admin Account
                      </h5>
                      <p className="text-center small">
                        Enter your admin ID &amp; password to login
                      </p>
                    </div>
                    {/* <form
                        className="row g-3 needs-validation"
                        onSubmit={this.loginUser}
                        noValidate
                      > */}
                    <div className="col-12">
                      <label htmlFor="email" className="form-label">
                        Admin ID
                      </label>
                      <div className="input-group has-validation">
                        <span
                          className="input-group-text"
                          id="inputGroupPrepend"
                        >
                          @
                        </span>
                        <input
                          type="text"
                          name="email"
                          className="form-control"
                          id="email"
                          // onChange={(e) => this.setState({ email: e.target.value })}
                          onChange={(e)=> e.target.value != "" && password != "" ? setButton(false) : setButton(true)}
                          ref={email}
                          required
                        />
                        <div className="invalid-feedback">
                          Please enter your username.
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        id="password"
                        // onChange={(e) => this.setState({ password: e.target.value })}
                        onChange={(e)=> e.target.value != "" && email != ""  ? setButton(false) : setButton(true)}
                        ref={password}
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter your password!
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="remember"
                          defaultValue="true"
                          id="rememberMe"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberMe"
                        >
                          Remember me
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      {/* <Link
                                to="/dashboard"
                                className="btn btn-primary w-100" 
                                >Login</Link> */}

                      <button
                        className="btn btn-primary w-100 mt-4 mb-2"
                        // type="submit"
                        onClick={loginUser}
                        disabled={button}
                      >
                        Login
                      </button>
                    </div>
                    <div className="col-12">
                      <p className="small mb-0">
                        This is not what you are looking for?{" "}
                        <a href="/">Go to website</a>
                      </p>
                    </div>
                    {/* </form> */}
                  </div>
                </div>
                <div className="credits">
                  Powered by <a href="https://Xtrava.com/">Xtrava</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <a
        href="#"
        className="back-to-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short" />
      </a>
    </div>
  );
}

export default Login;
